// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__TcyPJ","logoLeaf":"Logo_logoLeaf__SD3cx","logoMobileContainer":"Logo_logoMobileContainer__SIfY5","fadeIn":"Logo_fadeIn__Y-lH2"};